export enum PrivacySettingKey {
  PROFILE_VISIBILITY = 'PROFILE_VISIBILITY',
	BADGE_VISIBILITY ='BADGE_VISIBILITY',
	NAME_VISIBILITY = 'NAME_VISIBILITY',
	CONTACT_VISIBILITY ='CONTACT_VISIBILITY'
}
